import React from 'react'
import { i18n } from '../../index'
import css from './incentiveSales.css'
import type { WeeklySalesIncentiveReport } from './types'
type Props = {
  data: WeeklySalesIncentiveReport
  hasExpressCheckout: boolean
}

const WeekRow = ({ data, hasExpressCheckout }: Props) => {
  const { euroTarget, chainTarget, euroActual, week, mojovaEuroActual, kassuEuroActual, expressCheckoutEuroActual } =
    data
  return (
    <tr className={css.weekRow}>
      <td>{`${i18n.t('common.weekShort')} ${week}`}</td>
      <td>{chainTarget}</td>
      <td>{euroTarget}</td>
      <td>{euroActual}</td>
      <td>{kassuEuroActual}</td>
      <td>{mojovaEuroActual}</td>
      {hasExpressCheckout && <td>{expressCheckoutEuroActual}</td>}
    </tr>
  )
}

export default WeekRow
